import { memo } from 'react';
import { NavigationNode } from '~/lib/data-contract/auto-generated/api-model';
import styles from './navigation-item.module.css';
import ChevronRight from '$icons/chevron-right.svg';
import clsx from 'clsx';
import { CMSLink } from '~/shared/components';

type Props = {
    item: NavigationNode;
    onMenuClick?: () => void;
    isSubItem?: boolean;
    isActive?: boolean;
};

export const NavigationItem = memo(({ item, onMenuClick, isSubItem, isActive }: Props) => {
    const { children, link, linkColor } = item;
    const isSubList = !!children?.length;
    if (isSubList) {
        return (
            <button
                className={clsx('cleanButton', styles.itemButton, {
                    [styles.active]: isActive,
                })}
                onClick={onMenuClick}
                style={{ color: linkColor }}
            >
                {link?.title || link?.text}
                <ChevronRight aria-hidden="true" />
            </button>
        );
    }

    return (
        <CMSLink
            href={link?.url}
            style={{ color: linkColor }}
            className={clsx(styles.itemLink, {
                [styles.subItemLink]: isSubItem,
                ['hover-effect-underline-center']: isSubItem,
            })}
        >
            {link?.title || link?.text}
        </CMSLink>
    );
});
